import styled from 'styled-components';

// AplicacaoInfo = .machine-card do design Operacional.html:
//   badge cyan 36x36 + info (ttl + sub).
// Cyan accent fixo (nao varia por tipo) conforme design.

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1;
`;

// Badge cyan-soft com inset shadow — slot do icone (renderizado pelo
// componente como children dentro do Badge, ou via SVG inline).
export const Badge = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  flex: none;
  background: var(--cco-cyan-soft);
  color: var(--cco-cyan);
  box-shadow: inset 0 0 0 1px rgba(28, 176, 216, 0.35);
  display: grid;
  place-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--cco-ink);
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Sub = styled.div`
  font-size: 12.5px;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  b {
    color: var(--cco-cyan);
    font-weight: 700;
    margin-left: 3px;
  }
`;

// Compat (alguns lugares ainda fazem s.Line / s.ParqueLabel / s.StatusGroup)
export const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;
